var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testimonial"},[_c('p',[_vm._v(" \""+_vm._s(_vm.text)+"\" "),_c('br'),_c('strong',[_vm._v("- "+_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }